import { useEffect, useRef } from 'react';
import type { MutableRefObject } from 'react';

export function useEventListener(eventName: string, handler: EventListener) {
  const savedHandler = useRef<EventListener>();

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const eventListener = (event: CustomEvent) =>
      (savedHandler as MutableRefObject<EventListener>).current(event);

    window.addEventListener(eventName, eventListener as EventListener);

    return () => {
      window.removeEventListener(eventName, eventListener as EventListener);
    };
  }, [eventName]);
}
